import React from "react";
import {SerializedStyles} from "@emotion/react";

import {pr, textAlign} from "@pg-design/helpers-css";
import {Components, IOption, OptionProps, Select, SingleValueProps, ValueContainerProps} from "@pg-design/select-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

import {CalculatorValueType} from "../../types/CalculatorValueType";

interface IProps {
    value: number;
    valueType: CalculatorValueType;
    options: IOption[];
    updateValue: (type: CalculatorValueType, value: number) => void;
    wrapperStyle?: SerializedStyles | SerializedStyles[];
    dataTestId?: string;
}

export const CalculatorSelectInput = (props: IProps) => {
    const {value, valueType, options, updateValue, wrapperStyle} = props;
    return (
        <div css={wrapperStyle} data-testid={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.CREDIT_PERIOD}>
            <Select
                value={options.find((option) => option.value === value)}
                options={options}
                onChange={(option) => {
                    const convertedOption = option as IOption;
                    const value = typeof convertedOption.value === "number" ? convertedOption.value : parseInt(convertedOption.value);
                    updateValue(valueType, value);
                }}
                components={{SingleValue, ValueContainer, Option}}
            />
        </div>
    );
};

const SingleValue = (props: SingleValueProps) => {
    return (
        <Components.SingleValue {...props} css={textAlign("right")}>
            {props.children}
        </Components.SingleValue>
    );
};

const ValueContainer = (props: ValueContainerProps) => {
    return (
        <Components.ValueContainer {...props} css={pr(0)}>
            {props.children}
        </Components.ValueContainer>
    );
};

const Option = (props: OptionProps) => {
    return (
        <Components.Option {...props} css={textAlign("right")}>
            {props.children}
        </Components.Option>
    );
};
import React from "react";
import {SerializedStyles} from "@emotion/react";

import {pr, textAlign} from "@pg-design/helpers-css";
import {Components, IOption, OptionProps, Select, SingleValueProps, ValueContainerProps} from "@pg-design/select-module";
import {CREDIT_PAGES_IDS} from "@pg-mono/test-ids";

import {CalculatorValueType} from "../../types/CalculatorValueType";

interface IProps {
    value: number;
    valueType: CalculatorValueType;
    options: IOption[];
    updateValue: (type: CalculatorValueType, value: number) => void;
    wrapperStyle?: SerializedStyles | SerializedStyles[];
    dataTestId?: string;
}

export const CalculatorSelectInput = (props: IProps) => {
    const {value, valueType, options, updateValue, wrapperStyle} = props;
    return (
        <div css={wrapperStyle} data-testid={CREDIT_PAGES_IDS.COMPARE_CREDITS_SUBPAGE.CREDIT_PERIOD}>
            <Select
                value={options.find((option) => option.value === value)}
                options={options}
                onChange={(option) => {
                    const convertedOption = option as IOption;
                    const value = typeof convertedOption.value === "number" ? convertedOption.value : parseInt(convertedOption.value);
                    updateValue(valueType, value);
                }}
                components={{SingleValue, ValueContainer, Option}}
            />
        </div>
    );
};

const SingleValue = (props: SingleValueProps) => {
    return (
        <Components.SingleValue {...props} css={textAlign("right")}>
            {props.children}
        </Components.SingleValue>
    );
};

const ValueContainer = (props: ValueContainerProps) => {
    return (
        <Components.ValueContainer {...props} css={pr(0)}>
            {props.children}
        </Components.ValueContainer>
    );
};

const Option = (props: OptionProps) => {
    return (
        <Components.Option {...props} css={textAlign("right")}>
            {props.children}
        </Components.Option>
    );
};
